export default __webpack_public_path__ + "static/media/COSTAL20.e2d45544.png";